import { omit } from 'lodash-es';

import { cn } from '../cn';
import type { BreadcrumbProps } from './Breadcrumbs';

export default function Breadcrumb({ children, className, ...props }: BreadcrumbProps) {
  return (
    <div
      className={cn(
        'flex flex-row items-center gap-2 text-nowrap text-sm [&>svg]:h-4 [&>svg]:w-4',
        'text-[#475166] dark:text-white',
        className,
      )}
      {...omit(props, ['backwards'])}>
      {children}
    </div>
  );
}
